export const THDefaultDaypartHours = {
  breakfastTime: {
    breakfastTimeOpen: '04:00',
    breakfastTimeClose: '11:00',
  },
  lunchTime: {
    lunchTimeOpen: '11:00',
    lunchTimeClose: '14:00',
  },
  snackTime: {
    snackTimeOpen: '14:00',
    snackTimeClose: '17:00',
  },
  dinnerTime: {
    dinnerTimeOpen: '17:00',
    dinnerTimeClose: '19:00',
  },
  lateNightTime: {
    lateNightTimeOpen: '19:00',
    lateNightTimeClose: '23:00',
  },
};
